






































































import { Component, Vue, Prop } from "vue-property-decorator";
import QuestionImg from "@/components/question/question-img.vue";
import QuestionSelect from "@/components/question/question-select.vue";
import Empty from "@/components/empty.vue";
import { GetShixunList, GetCommit, GetTem } from "@/request/common";
@Component({
  components: {
    QuestionImg,
    QuestionSelect,
    Empty,
  },
})
export default class Name extends Vue {
  private questionIndex: any = null;
  private showAnswer: any = false;
  private maxH: any = null; // 图片的最大高度
  private data: any = [];
  private cTab: any = "";
  private ifReading: any = false; // 脉图设备是否已存在
  private ifOpen: any = false; // 是否打开过脉的设备
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }

  private changeTab(val: any) {
    this.cTab = this.systemInfo.SETTING.zongheRange[val];
    this.getData();
  }
  private countHeight() {
    const box = (this.$refs.imgBox as any).offsetHeight;
    this.maxH = box;
  }
  private IndexChange(index: any) {
    this.questionIndex = index;
    this.getDetail();
  }
  private changeSelect(val: any) {
    this.data[this.questionIndex].ifSelect = val;
  }
  private goBefore() {
    if (this.questionIndex == 0) {
      this.$message.warning("已经是第一题了");
      return;
    }
    this.questionIndex--;
    this.getDetail();
  }
  private goNext() {
    if (this.questionIndex == this.data.length - 1) {
      this.$message.warning("已经是最后一题了");
      return;
    }
    this.questionIndex++;
    this.getDetail();
  }
  private getData() {
    if (!this.cTab || !this.cTab.name) {
      const type = this.systemInfo.SETTING.zongheRange.keys[0];
      this.cTab = this.systemInfo.SETTING.zongheRange[type];
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        类别: this.cTab.name,
      },
    };
    GetShixunList(this, params, loading)
      .then((res: any) => {
        loading.close();
        // 初始化参数，根据页面需求初始化
        // ifSelect 是否答题
        // ifShowEdit 是否可以编辑
        // ifShowCorrect 是否显示正确答案
        // ifShowAnswer 是否显示答案
        // ifShowAnswerBtn 是否显示答案按钮
        // ifShowAnswerResult 是否显示答案结果
        res.forEach((element: any) => {
          element.ifSelect = false;
          element.ifShowEdit = true;
          element.ifShowCorrect = false;
          element.ifShowAnswer = true;
          element.ifShowAnswerBtn = true;
          element.ifShowAnswerResult = false;
          element.ifShowAnswerJiexi = false;
          // element.data.forEach((ele: any) => {
          //   if (ele.type == "多选" && !ele.answer) {
          //     ele.answer = [];
          //   }
          // });
        });
        this.data = res;
        this.questionIndex = 0;
        this.getDetail();
        this.countHeight();
      })
      .catch(() => {
        loading.close();
      });
  }
  private async getDetail() {
    if (this.data[this.questionIndex].data) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        question_template_id:
          this.data[this.questionIndex].question_template_id,
      },
    };
    GetTem(this, params, loading)
      .then(async (res: any) => {
        loading.close();
        // this.data = res;
        res.data.forEach((ele: any) => {
          if (ele.type == "多选" && !ele.answer) {
            ele.answer = [];
          }
        });
        let arr = JSON.parse(JSON.stringify(this.data));
        let obj = { ...this.data[this.questionIndex], ...res };
        arr[this.questionIndex] = obj;
        this.data = arr;
        this.$forceUpdate();
        // 如果支持设备脉，需要调取exe调整设备脉
        if (
          this.systemInfo.SETTING.iFHasDevicePulse &&
          this.cTab.name == "脉" &&
          res.data.length > 0
        ) {
          if (this.ifReading) {
            const option = this.data.data[0].options.find(
              (item: any) => item.value === this.data.data[0].correct
            );
            const val: any = option ? option.label : "";
            console.log(val, "control_hand", "start");
            const result = await window.electronMyAPI.changePulse(
              val,
              "control_hand",
              "start"
            );
            console.log(result);
            const loading2 = this.$loading({
              lock: true,
              text: "脉象切换中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (result) {
              this.ifOpen = true;
              loading2.close();
              console.log("返回值：" + result);
            }
          } else {
            console.log("检查", "check_hand", "检查");
            const checkResult = await window.electronMyAPI.changePulse(
              "检查",
              "check_hand",
              "检查"
            );
            console.log(checkResult);
            const loadingCheck = this.$loading({
              lock: true,
              text: "设备检查中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (checkResult) {
              if (checkResult == "success") {
                this.ifReading = true;
                loadingCheck.close();
                const option = this.data[
                  this.questionIndex
                ].data[0].options.find(
                  (item: any) =>
                    item.value === this.data[this.questionIndex].data[0].correct
                );
                const val: any = option ? option.label : "";
                console.log(val, "control_hand", "start");
                const result = await window.electronMyAPI.changePulse(
                  val,
                  "control_hand",
                  "start"
                );
                console.log(result);
                const loading2 = this.$loading({
                  lock: true,
                  text: "脉象切换中……",
                  spinner: "el-icon-loading",
                  customClass: "loadClass",
                  background: "rgba(255, 255, 255, 0.7)",
                });
                if (result) {
                  this.ifOpen = true;
                  loading2.close();
                  console.log("返回值：" + result);
                }
              } else {
                loadingCheck.close();
                alert("设备不存在");
              }
            }
          }
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private edit() {
    const d = this.data[this.questionIndex];
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      qts: d.data,
      template_type: d["类别"],
    };
    GetCommit(this, params, loading)
      .then((res: any) => {
        const d: any = JSON.parse(JSON.stringify(this.data));
        d[this.questionIndex]["评语"] = res;
        d[this.questionIndex].ifShowAnswerJiexi = true;
        this.data = d;
        this.$forceUpdate();
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.getData();
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        this.countHeight();
      })();
    };
  }
  private beforeDestroy(to: any, from: any, next: any) {
    console.log("离开页面");
    if (this.ifOpen) {
      console.log("关闭脉设备");
      console.log("停止", "control_hand", "stop");
      const result = window.electronMyAPI.changePulse(
        "停止",
        "control_hand",
        "stop"
      );
      console.log(result);
    }
  }
}
